import { type Clip } from '@air/api/types';
import {
  usePlayerFrameShortcut,
  usePlayerMuteShortcut,
  usePlayerPercentageSeekShortcut,
  usePlayerPlaybackRateShortcut,
  usePlayerPlayPauseShortcut,
  usePlayerVolumeShortcut,
} from '@air/component-player';

const SHORTCUT_SCOPE = 'video-visualizer';

export type UseVideoVisualizerShortcutsParams = {
  clip: Clip;
};

export const useVideoVisualizerShortcuts = ({ clip }: UseVideoVisualizerShortcutsParams) => {
  usePlayerFrameShortcut({
    clip,
    scope: SHORTCUT_SCOPE,
  });

  usePlayerPercentageSeekShortcut({
    scope: SHORTCUT_SCOPE,
  });

  usePlayerPlaybackRateShortcut({
    scope: SHORTCUT_SCOPE,
  });

  usePlayerPlayPauseShortcut({
    scope: SHORTCUT_SCOPE,
  });

  usePlayerMuteShortcut({
    scope: SHORTCUT_SCOPE,
  });

  usePlayerVolumeShortcut({
    scope: SHORTCUT_SCOPE,
    step: 0.1,
  });
};
